export default {
  property: {
    header: 'Commercial Property Insurance',
    body: `<div class="title-sm">Protection for Your Business Itself</div>
<p>Every day, you work hard to ensure that your business stays up and running. From serving your customers and offering
your products and services to providing your employees with jobs, your business is a powerhouse of activity.
That’s why it’s important to make sure your commercial property is protected because accidents do happen,
and the last thing you want to experience as a business owner is being out of commission and under the wrong policy.</p>

<p>With a custom Property Insurance policy from SIG & Associates, you can ensure that the building itself and the
personal property of your business is protected from minor accidents or a major financial loss. Our insurance
specialists can help you create a policy that keeps your small-to medium-size business
insured from top to bottom by covering such items as:</p>

<ul>
<li>Your building</li>
<li>All interior items (desks, furniture, etc.)</li>
<li>Any outdoor signs on your property</li>
<li>On-site equipment</li>
<li>Your inventory</li>
</ul>

<p>Other items that are typically found on a Property Insurance policy can include Builder’s Risk insurance and
Equipment Breakdown coverage. Builder’s Risk protects any materials or equipment from damage or loss
sustained during construction or remodeling, while Equipment Breakdown, or Boiler and Machinery,
keeps any electrical, electronic, or pressurized equipment on your premises insured from breakdowns or loss.</p>

<div class="title-sm">Additional Business Protection</div>

<p>In some cases, your business can save more by combining Property with Liability for the
convenience of having your business needs met.
To find out more about combining coverages, contact SIG & Associates today.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  general: {
    header: 'Commercial General Liability',
    body: `<div class="title-sm">Critical Assurance for the Protection of Your Business</div>

<p>Running a business is a major responsibility that can involve many risks.
Not only are you responsible for ensuring that your day-to-day operations run smoothly,
but you’re also accountable for keeping your employees and property insured from injuries and damages.
At SIG & Associates, we can help you create a policy that’s designed to safeguard the best interests
of your business - so you can focus on serving your customers and increasing your profits.</p>

<p>Commercial General Liability from SIG & Associates can prevent major financial losses if
your business is sued or held legally responsible in the event of bodily injury or damage.
With the proper policy, you can have most medical expenses, attorney fees,
settlements, and reimbursements covered. Coverages from SIG & Associates include:</p>

<ul>
<li>Premises Liability</li>
<li>Products and Completed Operations</li>
<li>Premises Medical</li>
<li>Fire Legal Liability</li>
<li>Casualty Coverage</li>
</ul>

<p>Other types of Commercial General Liability include Garage-keepers Liability and Employment Practices Liability.
If you run an auto service operation, having Garagekeepers Liability coverage will protect your customers’
vehicles from fire, vandalism, theft, or other damages. An option like Employment
Practices Liability will protect your business if an employee’s legal rights have been violated.</p>

<div class="title-sm">Additional Commercial Liability</div>

<p>Other specialty types of Commercial Liability, such as Foreign, Liquor, and
Concession Liability, can aid in furthering the safety of your business’s future.</p>

<ul>
<li><b>Foreign Liability</b> protects employees who travel out of the country
(for business purposes) in the event of injuries, damages and lawsuits.</li>
<li><b>Liquor Liability</b> includes covering damages and injuries in which your business is held
legally responsible as a result of serving liquor - from liquor establishments to office parties/special events.</li>
<li><b>Concession Liability</b> keeps your special event stand insured from damage,
accidents, or accidental injuries sustained to pedestrians.</li>
</ul>

<p>Since there are many types of liability coverages, it’s important to talk with a
specialist at SIG & Associates about the best options for your business.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  bop: {
    header: 'Business Owners Policy (BOP)',
    body: `<div class="title-sm">Combined Coverage for Special Advantages</div>

<p>At SIG & Associates, we’re committed to providing insurance solutions that keep small
to medium-sized businesses protected. That’s why we combine various coverage options into
one convenient package – for more benefits than a typical Business
policy and better savings through competitive pricing.</p>

<p>A Business Owners Policy (BOP) from SIG & Associates allows your business to
create a customized insurance policy that combines Property, Commercial General Liability,
and Crime Insurance, as well as additional coverage types based on your needs.</p>

<p>The proper Business Owners Policy can keep your day-to-day operations protected with options such as:</p>

<ul>
<li>Products and Completed Operations</li>
<li>Premises Liability</li>
<li>Premises Medical</li>
<li>Fire Legal Liability</li>
<li>Business Income Insurance</li>
<li>Building and Personal Property Protection</li>
<li>On-Site Equipment Insurance</li>
<li>Coverage for Inventory Loss</li>
<li>Crime Insurance</li>
</ul>

<div class="title-sm">Find Out if Your Business is Eligible</div>

<p>Since Business Owners Policies apply only to special types of businesses with specific needs,
operations, and risks, it’s important to contact a specialist at SIG & Associates
who can help you determine whether a BOP is right for your small or medium-sized business.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  marine: {
    header: 'Inland Marine Insurance',
    body: `<div class="title-sm">Off-Site Protection for Your Valued Assets</div>

<p>Your products and equipment are the backbone of your success as a company.
From transported goods and hauled equipment to storage items and even construction tools,
it’s important to keep your investments protected. With Inland Marine coverage,
you can avoid damages sustained in the event of accidents, theft, vandalism, or total loss.</p>

<p>At SIG & Associates, we’re dedicated to providing the coverage your business
needs for the asset protection it deserves. Our Inland Marine policy
insures that when your business is on the move, we’ll protect certain items, such as:</p>

<ul>
<li>Transported Property</li>
<li>Computer Equipment and Data</li>
<li>Contractor’s Tools</li>
<li>Artwork</li>
<li>Buildings Under Construction</li>
</ul>

<div class="title-sm">What Inland Marine Can Do for Your Business</div>

<p>No matter what business you’re in, an accident can happen at any time.
That’s why it’s important to have an Inland Marine policy from SIG & Associates
to provide your business with the appropriate coverage it needs during transit.</p>

<p>Since Inland Marine covers items outside of your standard Business Property Insurance policy,
having additional coverage to keep your equipment insured off-site is critical.
This coverage can also extend to protect your business’s goods or
equipment when transported by ocean and air, also known as Ocean Marine.</p>

<p>Contact an Inland Marine specialist at SIG & Associates today to find out how your
business can insure its most valuable assets while working or traveling off-site.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  auto: {
    header: 'Commercial Auto Insurance',
    body: `<div class="title-sm">Peace of Mind for Businesses On the Road</div>

<p>SIG & Associates understands the value of your commercial vehicles and the employees who drive them.
From trips across the country to local deliveries and promotions, your mobile business
fleet takes on the open road to keep operations running smoothly – but accidents do happen.</p>

<p>To prevent losing your hard-earned revenue due to an auto accident, you’ll want to ensure
that your vehicles, products, and drivers are insured in the event of property or vehicle
damage, bodily injury, legal costs, and more. With Commercial Auto Insurance from
SIG & Associates, we’ll work with you one-on-one to create a customized policy that may include:</p>

<ul>
<li>Bodily Injury Liability</li>
<li>Medical Payments</li>
<li>Personal Injury Protection (PIP) Coverage</li>
<li>Comprehensive Coverage</li>
<li>Collision Coverage</li>
<li>GAP Coverage</li>
<li>Uninsured and Under-insured Motorist Coverage</li>
</ul>

<p>Additional options like <b>Bailee Coverage</b> are available if needed. Bailee Coverage insures property
loss or damage when in your company’s care, control, or custody –
for example: product protection for items on a semi or delivery truck.</p>

<p>Since Commercial Auto Insurance coverage varies, it’s important to discuss your business’s
options with a specialist at SIG & Associates who can help you determine
the proper amount of coverage for all your commercial needs.</p>

<p>Auto Insurance is an essential financial decision that will keep your business covered.
The next time your fleet takes the road, make sure it’s
protected with Commercial Auto policy from SIG & Associates.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  umbrella: {
    header: 'Commercial Umbrella Insurance',
    body: `<div class="title-sm">Extra Protection that Keeps You in Business</div>

<p>As a business owner, keeping your business insured is one of the most important financial decisions you can make.
But if you don’t have a sufficient amount of coverage, your current policy may not have the extra layer
of protection needed for situations that can jeopardize your finances, or even your operations.</p>

<p>With Commercial Umbrella Insurance from SIG & Associates, you can protect your business
and your assets in the event that your company gets sued in a major lawsuit.</p>

<p>A Commercial Umbrella policy will provide your business with additional coverage should a lawsuit
or major accident exceed the limits of your existing, or underlying, General, Auto, or other business liability policy.
It can also insure an incident that occurs outside of your coverage territory.</p>

<div class="title-sm">What Does Commercial Umbrella Insurance Cover?</div>

<p>Major lawsuits are a result of accidents that occur either on or off the premises of your business.
The following are examples of situations where Commercial Umbrella coverage can safeguard your business:</p>

<ul>
<li>Accidental falls or slips on your property</li>
<li>A carbon monoxide leak in your building</li>
<li>Libel, slander, or invasion of privacy</li>
<li>If one of your products causes injury or illness</li>
<li>If a fire in your building damages other property</li>
<li>Violations of Employment Practices Liability</li>
<li>If your business vehicle is involved in an accident</li>
</ul>

<div class="title-sm">How Much Umbrella Coverage is Enough?</div>

<p>Since lawsuits can be expensive and accidents do happen, you can never be too careful with your coverage options.
That’s why at SIG & Associates, our helpful insurance experts will work with the individual needs of
your business to find a level of protection that keeps you and your operations secure.
Commercial Umbrella Insurance is simply an affordable coverage that can help you avoid major losses.</p>

<p>Protect your business personally and financially with a Commercial Umbrella policy from SIG & Associates.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  professional: {
    header: 'Professional Liability',
    body: `<div class="title-sm">Mistakes Happen</div>
<p>In today’s litigious society, lawsuits against businesses are common.
And as a business owner, you need to be prepared to protect the integrity
of your company if an incident or mistake turns into a claim.</p>

<p>At SIG & Associates, we understand that mistakes happen.
That’s why we’re committed to helping you create a Professional Liability policy
that keeps your day-to-day operations protected should your business be held legally liable.</p>

<div class="title-sm">What Does Professional Liability Cover?</div>

<p>While it’s important for your business to have general liability
coverage for property damage and bodily injury, SIG & Associates
recommends adding Professional Liability Insurance to your business portfolio because
it insures the people and/or entities of your business from negligent
claims made by third parties, or even internal sources.</p>

<p>From failure to render a service to malpractice suits,
Professional Liability can provide a wide variety of options, such as:</p>

<ul>
<li><b>Errors and Omissions Liability (E & O)</b> – E & O covers any mistakes made by employees who work on behalf of
your business, if your business charges fees for your services. It can include coverage for any errors such as
failure to perform or violations of contract. Depending on your industry, your insurance needs will vary.</li>
<li><b>Directors and Officers Liability (D & O)</b> - Having financial protection for your business’s Directors
and Officers can prevent loss in the event that they are held liable from actions related to their corporate positions.
This can include anything from conflicts of interest to mismanagement of company assets and violation of laws.</li>
<li><b>Fiduciary Liability</b> - Fiduciary covers claims that involve the violation of the Employee Retirement
Income Security Act, or ERISA. If a manager, for example, violates the financial obligations of ERISA,
having the right coverage can protect your company if held liable in situations from
imprudent investments to failure to enroll employees.</li>
<li><b>Employment Practices Liability</b> - With proper insurance, your business can be
protected if a worker claims that his or her rights have been violated. This can include
violations from sexual harassment and discrimination to violations of the Americans with
Disabilities Act (ADA), mismanagement of employee benefit plans, and wrongful termination.</li>
</ul>

<p>Contact a representative with SIG & Associates today to prevent mistakes and errors
from becoming major losses for your business.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  workers: {
    header: 'Workers Compensation',
    body: `<div class="title-sm">Workers Compensation</div>

<p>SIG & Associates understands the value of good employees. We know that your day-to-day
operations depend on their hard work, expertise, and dedication, and if you supply them
with quality benefits and plans, they can work with the peace of mind assurance that they’re properly protected.</p>

<p>But should an accident happen, having the right Workers Compensation plan from
SIG & Associates can allow your business to ensure payments and cover expenses if an
employee is injured from a work-related accident. Injuries can range from car
accidents and back injuries to equipment malfunctions and, in some unfortunate cases, death.</p>

<p>Workers Compensation can cover financial obligations such as:</p>

<ul>
<li>An injured employee’s medical expenses/treatment</li>
<li>The replacement of lost wages from injury time off</li>
</ul>

<p>If your business does not offer Workers Compensation, serious injuries that occur on the
job could lead to an employee suing your company for damages. That’s why it’s important
to discuss your options with a specialist at SIG & Associates who can help you
find the right coverage options for all your business needs.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  crime: {
    header: 'Crime Insurance',
    body: `<div class="title-sm">Specialty Coverage for Dishonesty in the Workplace</div>

<p>Unfortunately, crime and employee dishonesty can happen. As a business owner,
sometimes it’s impossible to know whether the employees you hire are an honest
fit for the job, and by the time you discover the truth, the damages can be costly.</p>

<p>At SIG & Associates, we can help your business develop a plan that keeps
your assets protected in the event of such a specific circumstance.
With Crime Insurance, your policy can include coverage for various situations, such as:</p>

<ul>
<li>Robbery or Burglary</li>
<li>Computer Fraud</li>
<li>Employee Dishonesty</li>
<li>Theft of Business Property</li>
<li>Forgery</li>
</ul>

<p>Since there are limitations to your commercial crime policy, you should carefully discuss your options with
SIG & Associates to find out what kind of insurance your business needs based
on your current situation and potential risks.</p>

<p>Don’t lose important data or finances on the account of a dishonest employee’s actions.
Keep your business secure with Crime Insurance from SIG & Associates.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  }
}



// WEBPACK FOOTER //
// ./src/helpers/businessHelper.js